import { type ComponentProps } from "react";

import { CheckIcon } from "~/icons";
import { cn } from "~/lib/utils";

export function ServiceList({ className, ...props }: ComponentProps<"ul">) {
    return <ul className={cn("flex flex-col gap-y-4", className)} {...props} />;
}

export function ServiceListItem({ className, children, ...props }: ComponentProps<"li">) {
    return (
        <li className={cn("flex gap-2 items-start text-[15px]", className)} {...props}>
            <div className="pt-[5px] shrink-0">
                <CheckIcon className="text-secondary !rotate-0" />
            </div>
            {children}
        </li>
    );
}
